/**
 * @author xyguo 2020-9-10
 * 查看证书信息
 */
import React from "react";
import { connect } from "dva";
import "@/styles/containers/personManage/personInfoDetail/index.less";
import { component_tool, framework_tool, utils_tool } from "../../../../tool";
import { AudienceGroupItem } from '@/components';
let { Session } = utils_tool

let {
  WizCard,
  WizRow,
  WizCol,
  // WizSurveyAudience,
  WizTabs,
} = component_tool;
let { WizContainer,ossFileUtils } = framework_tool;

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
      if (history.location.pathname === '/cert/certList/certInfo') {
          if (history.location && history.location.record) {
              record = history.location.record
              Session.set('certInfo', record)
          } else {
              record = Session.get('certInfo') || {}
          }
      }
  }
  return record
}

class CertInfo extends WizContainer {
  componentName = "CertInfo";
  constructor(props) {
    super(props);
    this.state = {
      record: getParamRecord(props.history)
  }
  }

  _renderTitleInfoRow(leftName, leftValue = '', rightName, rightValue = '') {
    return rightName?(
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
        <WizCol className='text_right' span={3} offset={2}>{rightName + '：'}</WizCol>
        <WizCol span={6}>{rightValue}</WizCol>
      </WizRow>
    ) :
    (
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
      </WizRow>
    )
  }

  getImgInfo = () => {
    let record = this.state.record
    let url = getOssFilePath(record.icon)
    // ossFileUtils.getOssFile(
    //   record.icon,
    //   record.fileName,
    //   record.fileMimeType,
    //   record.fileSize,
    //   record.fileUri,
    // ).url
    url = record.icon ? url : constants.files.sys_img_non_existent_png;
    return <div style={{ display: 'flex', 'justify-content': 'flex-start', marginRight: 0, }}>
      <div>
        <img  src={url} />
      </div>
    </div>
  }

  getLevelName = ()=>{
    let record = this.state.record
    let levelName = "";
    let levelData = [
      {code: 0, msg: '初级'},
      {code: 1, msg: '中级'},
      {code: 2, msg: '高级'},
      {code: 3, msg: '一星'},
      {code: 4, msg: '二星'},
      {code: 5, msg: '三星'},
      {code: 6, msg: '四星'},
      {code: 7, msg: '五星'},
      {code: 8, msg: '六星'},
      {code: 9, msg: '七星'}
    ];
    levelData.forEach(e=>{
      if(e.code=== record.level){
        levelName = e.msg
      }
    })
    return levelName
  }

  _render() {
   const info = this.state.record;
   let data = [];
   if (info.type == 1){
     //培训证书
     let validTime = info.validTime;
     if(validTime && validTime ==-1){
       validTime = '永久有效';
     }else if(validTime && validTime>0){
       validTime = validTime+'月';
     }
     data.push(
     this._renderTitleInfoRow('证书名称', info.name, '证书分类', info.categoryStr),
     this._renderTitleInfoRow('证书类型', info.classify === 1 ?'个人':'店端', '证书类别', info.type === 1 ? '培训证书' :'社会证书'),
     this._renderTitleInfoRow('证书级别', this.getLevelName(), '证书代码', info.code),
     this._renderTitleInfoRow('流水号', info.serial, '有效期', validTime),
     this._renderTitleInfoRow('是否自动挂靠', info.autoLink === 1 ? '是' : '否', '是否允许共建', info.allowUnite ===1?'是':'否'),
     this._renderTitleInfoRow('是否允许申请', info.needCheck === 1 ? '是' : '否','证书图标', this.getImgInfo()),
     )
   }else{
     //社会证书
     data.push(
       this._renderTitleInfoRow('证书名称', info.name, '证书分类', info.categoryStr),
       this._renderTitleInfoRow('证书类型', info.classify === 1 ?'个人':'店端', '证书类别', info.type === 1 ? '培训证书' :'社会证书'),
       this._renderTitleInfoRow('证书级别', this.getLevelName(), '是否自动挂靠', info.autoLink === 1 ? '是' : '否'),
       this._renderTitleInfoRow('是否允许共建', info.allowUnite ===1?'是':'否','是否允许申请', info.needCheck === 1 ? '是' : '否'),
       this._renderTitleInfoRow('证书图标', this.getImgInfo(),null,null),
     )
   }

    return (
      <>
        <WizCard>
          {data}
        </WizCard>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey="1">
            <WizTabs.TabPane tab="适用范围" key="1">
              {/* <WizDataTable {...info} /> */}
              {/* <WizRow>
                <WizTypography.Paragraph strong>适用范围</WizTypography.Paragraph>
              </WizRow> */}
              {/* <WizSurveyAudience labelWidth={4} style={{ width: '90%' }}  data={info['authData'] || {}} /> */}
              <AudienceGroupItem { ...info.authData } />

            </WizTabs.TabPane>
          </WizTabs>
        </WizCard>
      </>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(CertInfo);
